import { render, staticRenderFns } from "./Popular_proInternet.vue?vue&type=template&id=09c95714&"
import script from "./Popular_proInternet.vue?vue&type=script&lang=js&"
export * from "./Popular_proInternet.vue?vue&type=script&lang=js&"
import style0 from "./Popular_proInternet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports